import React, { useEffect, useState } from "react";
import { backend } from "../../services/backend";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { userBackend } from "../../services";

const DocumentUploadForm = () => {
  const [documentFile, setDocumentFile] = useState<string>(
    ""
  );
  const [update, setUpdate] = useState(false);
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const session = State.session

  if (!session) {
    return null;
  }

  useEffect(() => {
    userBackend.getUserFiles(session.id).then((res) => {
      console.log(res);
      dispatch(actions.currentUserPhotos(res.files))
      const docFiles = res.files.filter((file) => {
        return file.category === "document"
      });
      const url = docFiles[docFiles.length - 1].url.replace("uploads/", "/files/")
      setDocumentFile(url)
   }).catch((e) => {
    console.log(e)
   })
  }, [update])

  const onFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setDocumentFile(fileURL);
    }
    if (file) {
      userBackend.loadUserDocument(file).then((res) => {
        console.log(res);
        setUpdate(state => !state)
      });
    }
  };

  return (
    <div className="form">
      <form>
        <div className="">
          <div className="inputRow">
            <label>
              Паспорт (лицевая сторона)
              <span className="requireSymbol" />
            </label>
            <label htmlFor="file-upload-1">
              <div className="fileInput">
                <div className="fileInputText">
                  Перенесите или Выберите файл
                </div>
              </div>
              <input
                type="file"
                onChange={onFileUpload}
                accept="image/*"
                id="file-upload-1"
              />
            </label>
            <div className="fileDisplayContainer">
              <img src={documentFile} />
            </div>
          </div>
          {/* <div className="inputRow">
            <label>
              Паспорт (лицевая сторона)
              <span className="requireSymbol" />
            </label>
            <label htmlFor="file-upload-1">
              <div className="fileInput">
                <div className="fileInputText">
                  Перенесите или Выберите файл
                </div>
              </div>
              <input type="file" id="file-upload-1" />
            </label>
            <div className="fileDisplayContainer">
                <img src="/images/document.png" />
            </div>
          </div> */}
        </div>
      </form>
    </div>
  );
};

export default DocumentUploadForm;
